/**验证邮箱。 如果没有邮箱。 跳转页面,重新填写邮箱 */

import loginService from "./loginService";

const valideEmail=async function()
{
  console.log("valideEmail >>> 验证邮箱!")

  var ra_wxUser=await loginService.getLoginUser();
  if(ra_wxUser && ra_wxUser!="undefined")
  {
      // 如果有登录账户，但是没有邮箱。 
      if(ra_wxUser && !ra_wxUser.uMail)
      {
        return false;
      }
  }
  return true;
}

export default valideEmail;



// WEBPACK FOOTER //
// ./src/plugin/extendFn/valideEmail.js